import { AbstractControl, FormControl } from '@angular/forms';
import {
  AlarmRuleActionResolvedAlarm,
  AlarmRuleActionType,
} from '../../../../../../../types/dtos/alarm-rule-action.dto';
import { AlarmRuleActionFormDto } from '../../../../../../../types/dtos/alarm-rule.dto';
import { BaseRuleAction } from '../base-rule-action';
import { AlarmResolved } from './alarm-resolved';

export class AlarmResolvedRuleAction extends BaseRuleAction {
  public getDescription(): string {
    return 'common.alarm-rule.action.alarm-resolved.description';
  }

  public getIcon(): string {
    return 'alarm_off';
  }

  public getName(): string {
    return 'common.alarm-rule.action.alarm-resolved.title';
  }

  public getType(): AlarmRuleActionType {
    return AlarmRuleActionType.ALARM_RESOLVED;
  }

  public getEditorComponent(): any {
    return AlarmResolved;
  }

  public override configToFrom(data: AlarmRuleActionResolvedAlarm): Record<string, unknown> {
    return {
      alarmType: data.alarmType,
    };
  }

  public formToConfig(form: AlarmRuleActionFormDto): Record<string, unknown> {
    return {
      alarmType: form.alarmType ?? [],
    };
  }

  public getFromControls(): Record<string, AbstractControl> {
    return {
      alarmType: new FormControl<string[]>([]),
    };
  }
}